import {Action} from '@ngrx/store';
import {Deserialize, Serialize} from 'cerialize';
import {BijbEventsState} from '../states/bijb-events-state';
import {GetBijbEventsAction} from '../actions/bijb-event/get-events-action';
import {GetBijbEventsSuccessAction} from '../actions/bijb-event/get-events-success-action';
import {GetBijbEventsErrorAction} from '../actions/bijb-event/get-events-error-action';

const initialState = new BijbEventsState();

export function BijbEventsReducer(serializedState: any = Serialize(initialState), action: Action): any {
  const state: BijbEventsState = Deserialize(serializedState, BijbEventsState);

  switch (action.type) {
    case GetBijbEventsAction.type:
      state.ready = false;
      state.error = null;
      break;

    case GetBijbEventsSuccessAction.type:
      state.ready = true;
      state.bijbEvents = (<GetBijbEventsSuccessAction>action).bijbEvents;
      state.error = null;
      break;

    case GetBijbEventsErrorAction.type:
      state.ready = true;
      state.bijbEvents = null;
      state.error = (<GetBijbEventsErrorAction>action).error;
      break;

    default:
      return serializedState;
  }

  return Serialize(state);
}
